var map = {
	"./avatar.png": "4c77",
	"./beard.png": "826c",
	"./hacker.png": "82a6",
	"./man.png": "331d",
	"./man1.png": "2826",
	"./man2.png": "31aa",
	"./woman.png": "c63e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "63b1";